import { render, staticRenderFns } from "./ExtractRequests.vue?vue&type=template&id=6316a4ca&"
import script from "./ExtractRequests.vue?vue&type=script&lang=js&"
export * from "./ExtractRequests.vue?vue&type=script&lang=js&"
import style0 from "./ExtractRequests.vue?vue&type=style&index=0&id=6316a4ca&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6316a4ca')) {
      api.createRecord('6316a4ca', component.options)
    } else {
      api.reload('6316a4ca', component.options)
    }
    module.hot.accept("./ExtractRequests.vue?vue&type=template&id=6316a4ca&", function () {
      api.rerender('6316a4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExtractRequests.vue"
export default component.exports